type Validator<T = unknown> = (val: T) => boolean | string;

export type ValidateConfig<Form extends Record<string, unknown>> = {
  [key in keyof Form]?: Validator<Form[key]>[];
};

export const validate = (validators: Validator[]) => (value: unknown) => {
  const validateResult = validators.reduce((acc, validator) => {
    const val = validator(value);
    if (val) {
      return val;
    }
    return acc;
  }, false);

  return validateResult;
};

export const createValidator = <Form extends Record<string, unknown>>(config: ValidateConfig<Form>) => {
  const configEntries = Object.entries(config);
  return (fields: Partial<Form>, field?: keyof Form): [Record<keyof Form, string | boolean>, boolean] => {
    let isNotValid = false;

    const validateRes = configEntries.reduce((acc, [key, validators]) => {
      if (field && field !== key) {
        return acc;
      }
      const validateResult = validate(validators)(fields[key]);

      if (validateResult) {
        isNotValid = true;
        return {
          ...acc,
          [key]: validateResult,
        };
      }

      return acc;
    }, {} as Record<keyof Form, string | boolean>);
    return [validateRes, isNotValid];
  };
};

export const required = (val: unknown) => (!val ? 'Обязательное поле' : false);
